var map = {
	"./andon-b.png": "XUwf",
	"./andon.png": "NDsO",
	"./basic-b.png": "E074",
	"./basic.png": "EWBo",
	"./desk-b.png": "w2fY",
	"./desk.png": "ZE6D",
	"./develop-b.png": "BYuN",
	"./develop.png": "vy3R",
	"./flow-b.png": "ZtQJ",
	"./flow.png": "psj/",
	"./iot-b.png": "QK0W",
	"./iot.png": "Y6b6",
	"./kanban-b.png": "9wbG",
	"./kanban.png": "wjuh",
	"./mes-b.png": "n254",
	"./mes.png": "HCK9",
	"./qms-b.png": "dT7f",
	"./qms.png": "NpcC",
	"./report-b.png": "QAMK",
	"./report.png": "RtKt",
	"./srm-b.png": "klN/",
	"./srm.png": "pNj+",
	"./system-b.png": "2JBW",
	"./system.png": "hYDG",
	"./wms-b.png": "wOM7",
	"./wms.png": "TdYq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2g0c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/nav/items ^\.\/.*\.png$
// module id = 2g0c
// module chunks = 698